import { ConversationBulkActionType } from 'lib-shared-types-api';

/**
 * Represents the map of converting the API bulk action type to the type defined
 * by the frontend. This is used to transform the response of the APIs, as well
 * as in the bulk actions modal implementation.
 */
export const conversationBulkActionTypeMap: Record<
  string,
  ConversationBulkActionType
> = {
  ['Add internal note']: 'add_internal_note',
  ['Add tag']: 'add_tag',
  ['Cancel CSAT']: 'cancel_csat',
  ['Claim']: 'claim',
  ['Close']: 'close',
  ['Remove tag']: 'remove_tag',
  ['Send reply']: 'send_reply',
  ['Transfer to queue']: 'transfer_to_queue',
  ['Link']: 'link',
};
